import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, getMarginBottomClass } from '../../utils/marginBottom/index.js';
import kebabCase from 'lodash/fp/kebabCase';
import styles from './logo.css.js';

var Logo = function Logo(_ref) {
  var id = _ref.id,
      _ref$textMap = _ref.textMap,
      textMap = _ref$textMap === void 0 ? {} : _ref$textMap,
      data = _ref.data,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom,
      rest = _objectWithoutProperties(_ref, ["id", "textMap", "data", "marginBottom"]);

  var svgId = id || "".concat(kebabCase(data.title), "-logo");
  var titleId = "".concat(svgId, "-title");

  var _data$viewBox$split = data.viewBox.split(' '),
      _data$viewBox$split2 = _slicedToArray(_data$viewBox$split, 4),
      width = _data$viewBox$split2[2],
      height = _data$viewBox$split2[3];

  return React.createElement("span", {
    className: cn(styles.LogoWrapper, getMarginBottomClass(marginBottom))
  }, React.createElement("canvas", {
    className: styles.stretcher,
    width: width,
    height: height,
    "aria-hidden": true
  }), React.createElement("svg", _extends({
    id: svgId,
    className: styles.Logo,
    "aria-labelledby": titleId,
    focusable: "false",
    role: "img",
    version: "1.1",
    viewBox: data.viewBox
  }, rest), React.createElement("title", {
    id: titleId
  }, textMap.title || data.title), data.svgContent));
};

Logo.displayName = 'Logo';
Logo.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,

  /** docgen-ignore */
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    viewBox: PropTypes.string.isRequired,
    svgContent: PropTypes.node.isRequired
  }).isRequired,
  textMap: PropTypes.shape({
    title: PropTypes.node
  }),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default Logo;
export { Logo };